import { type ApiReservationClass } from './class';
import useResaClass, { type ReservationClass } from './resaClass';

import { logException } from '@/common/utils/logger';

export enum PricingTypes {
    flatFees = 'flatFees',
    powerSupplyFees = 'powerSupplyFees',
    eChargingPrices = 'eChargingPrices',
    timeslotsPrices = 'timeslotsPrices',
    flatDays = 'flatDays',
    hours = 'hours',
}


export interface ApiPricing {
    id?: string | number;
    documentId: string;
    periodStart: Date | string;
    periodEnd: Date | string;
    timeStart: Date | string;
    timeEnd: Date | string;
    price: number;
    unit: string;
    weekDays: JSON; 
}
export interface ToApiPricing {
    id?: string | number;
    documentId?: string;
    periodStart: Date | string;
    periodEnd: Date | string;
    timeStart: Date | string;
    timeEnd: Date | string;
    price: number;
    unit: string;
    weekDays: JSON; 
}

export interface Pricing {
    periodStart: Date | string;
    periodEnd: Date | string;
    timeStart?: Date;
    timeEnd?: Date;
    price: number;
    unit?: string;
    weekDays?: JSON; 
    id?: number;
    documentId?: string;
}

export interface TablePricing {
    periodStart: Date | null;
    periodEnd: Date | null;
    timeStart: string | null; 
    timeEnd: string | null;
    price: number;
    unit?: string;
    weekDays?: JSON; 
    biller: string;
}

export interface ApiInvoice {
    id?: string | number;
    documentId: string;
    userId: string;
    calculatedPrice: number;
    date: string;
    pricing: { data: ApiPricing };
    reservationClass: { data: ApiReservationClass };
}

export interface Invoice {
    userId: string;
    calculatedPrice: number;
    date: Date;
    pricing: Pricing;
    reservationClass: ReservationClass;
}


export const apiInvoiceToInvoice = (apiResponse: ApiInvoice): Invoice => {
    const { 
        userId,
        calculatedPrice,
        date,
        pricing,
        reservationClass } = apiResponse;

    return {
        calculatedPrice,
        date,
        pricing: pricing?.data ? apiPricingToPricing(pricing.data) : null,
        reservationClass: reservationClass?.data ? useResaClass.apiResaClassToResaClass(reservationClass.data) : null,
        userId,
    };
}; 


const pricingToApiPricing = (pricing: Pricing): ApiPricing => {
    const {
        periodStart,
        periodEnd,
        timeStart,
        timeEnd,
        price,
        unit,
        weekDays,
        documentId
    } = pricing;

    return ({
        periodEnd,
        periodStart,
        price,
        timeEnd,
        timeStart,
        unit,
        weekDays,
        documentId
        
    });
};

export const apiPricingToPricing = (apiResponse: ApiPricing): Pricing => {
    const data = apiResponse;
    if (data.id === undefined && !data.documentId) { 
        throw new Error('Missing id or documentId in ApiPricing');
    }

    try {
        const {
            periodEnd,
            periodStart,
            price,
            timeEnd,
            timeStart,
            documentId
            /*
             *    periodStart,
             *    periodEnd,
             *    timeStart,
             *    timeEnd,
             *    price,
             *    unit,
             *    weekDays 
             */
        } = data;

        return ({
            id: data.id !== undefined && data.id !== null && !Number.isNaN(Number(data.id)) ? Number(data.id) : undefined,
            periodEnd,
            periodStart,
            price,
            timeEnd,
            timeStart,
            documentId
            /*
             * unit,
             *  weekDays
             */
        });
    } catch (error) {
        logException(error, { id: data.id, documentId: data.documentId });
        throw error;
    }
};

export const apiPricingsToPricings = (apiResponse: ApiPricing[]): Pricing[] => {
    if (apiResponse.length > 0) {
        return apiResponse.map(item => {
            return apiPricingToPricing(item);
        });
    } else {
        return []; 
    }
};


const usePricing = {
    apiPricingToPricing,
    apiPricingsToPricings,
    pricingToApiPricing
};

export default usePricing;